import { UserServiceClient } from 'fitbeat.api-clients';
import { useEffect, useState } from 'react';
import { getApiConfig } from '../../config';
import { AuthTokenBuilder } from '../../utils';
import { Logger } from '../../utils/Logger';

export const useGetVideoUrl = (videoName: string): string | null => {
  const [videoUrl, setVideoUrl] = useState(null);
  useEffect(() => {
    const authenticatedUserServiceClient = new UserServiceClient(
      getApiConfig(),
      fetch,
      Logger.debug,
      new AuthTokenBuilder(),
    );
    const getVideoRespose = async () => {
      const videoRespone = await authenticatedUserServiceClient.getVideoUrlFor(
        videoName,
      );
      setVideoUrl(videoRespone.videoUrl);
    };
    getVideoRespose().catch((e) => Logger.notify(e));
  }, []);
  return videoUrl;
};
